import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { isEmpty } from "lodash";
import ErrorBoundary from "components/ErrorBoundary";
import ConfigurationTable from "./components/ConfigurationTable";
import SearchContainer from "./components/SearchContainer";
import CEConfiguration from "components/CEConfiguration";
import CEContract from "components/CEContract";
import useAxios from "hooks/useAxios";
import { onExport, getUpdatedFilter } from "utils/helper";
import { isBoolean } from "lodash";
import Drawer from "components/Drawer";
import ProgramNotes from "components/ProgramNotes";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

const initialFilterBySearch = {
  coveredEntityName: "",
};

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: "startDate",
  order: "desc",
  filters: [],
};

let selectedCoveredEntity = {};

const Configuration = (props) => {
  const { module, orgId } = props;
  const API = useAxios();
  const [state, updateState] = useState({
    data: [],
    coveredEntity: [],
    loading: false,
    selectedEntity: "",
    coveredId: "",
    records: 0,
    reset: false,
  });
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);

  const [isOpenConfig, setOpenConfig] = useState(false);
  const [isOpenContract, setOpenContract] = useState(false);
  const [isOpenProgram, setOpenProgram] = useState(false);
  const [ceId, setCEId] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState([]);
  const [resetFlag, SetResetFlag] = useState(false);

  let selectedCEId = window.selectedCoveredEntittyId.toString();
  let { tenantID, coveredEntityID } = selectedCoveredEntity;
  const setState = (state) => updateState((pre) => ({ ...pre, ...state }));
  useEffect(() => {
    if (isOpenProgram == true) {

      onHandleManualProgram()
    }
    if (isOpenConfig == true) {
      editCEConfiguration()
    }
    if (isOpenContract == true) {
      setOpenContract(false);

    }

  }, [orgId])
  useEffect(() => {
    fetchInvoiceStatus();
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: "startDate",
      order: "desc",
      filters: [],
    };
    setState({ data: [], records: 0 });
    selectedCoveredEntity = {};
  }, [orgId]);

  const fetchInvoiceStatus = async () => {
    try {
      const { data } = await API.get("Config/TypeStatus/InvoiceCycleStatus");
      if (data) {
        setInvoiceStatus(data);
        setState({ loading: false });
      } else {
        setState({ loading: false });
      }
    } catch (error) {
      setState({ loading: false });
    }
  };
  const onManualSearch = async () => {
    setOpenProgram(true);
  };
  const onHandleManualProgram = () => {
    setOpenProgram(!isOpenProgram);
  };

  const fetchContractConfig = async (pageDetails = {}, hasColumnFilter) => {

    setState({ loading: true });
    let filter = { ...pageDetails };
    if (hasColumnFilter) {

      filter = { ...initialFilters, ...pageDetails }

      // filter.filters = [...initialFilters.filters, ...pageDetails.filters];

      filter.filters = filter.filters

      initialFilters = filter;
    } else {
      initialFilters = { ...initialFilters, ...filter };
    }
    let { tenantID, coveredEntityID } = selectedCoveredEntity;
    try {
      const { data } = await API.post(
        `Config/ceconfig/cecontracts/${coveredEntityID}`,
        initialFilters
      );
      if (data) {
        setState({
          data: data.items,
          records: data.totalRecords,
          loading: false,
        });
      } else {
        setState({
          data: [],
          records: 0,
          loading: false,
        });
      }
    } catch (error) {
      setState({ loading: false, data: [], records: 0 });
    }
  };

  const onSearchConfiguration = async (filters) => {
    const { coveredEntityName } = filters;
    let ce = coveredEntityName.toString();
    if (coveredEntityName && !isEmpty(ce)) {
      initialFilters.filters = getUpdatedFilter(
        "coveredEntityID",
        parseInt(coveredEntityName),
        initialFilters
      );
      initialFilters.currentPage = 1;
      fetchContractConfig(initialFilters);
    }
  };

  const onReset = () => {
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: "startDate",
      order: "desc",
      filters: [],
    };
    setState({ data: [], reset: !state.reset, records: 0 });
    selectedCoveredEntity = {};
    SetResetFlag(true);
  };

  const handleExport = () => {
    let { tenantID, coveredEntityID } = selectedCoveredEntity;
    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}Config/ceconfig/ExportAll/${coveredEntityID}?access_token=${access_token}`;
    onExport(action, initialFilters);
  };

  const handleExport2 = async () => {
    let { tenantID, coveredEntityID } = selectedCoveredEntity;

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.CEId = coveredEntityID;
    //filterObj.CoveredEntityIDS = coveredEntityID;
    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "configuration";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(initialFilters);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };


  const onPageChange = (filter, hasFilter) => {
    if (hasFilter) {
      fetchContractConfig(filter, true);
    } else {
      fetchContractConfig(filter);
    }
  };

  const handleSearchColumnFilters = async (columnFilters, filterCancel) => {

    if (filterCancel == true) { await fetchContractConfig(columnFilters) }

    else if (filterCancel == false) { await fetchContractConfig(columnFilters, true); }
  };

  const handleUpdateEntity = (entity) => {
    selectedCoveredEntity = entity;
  };

  const refetch = (hasReset) => {
    if (hasReset) {
      initialFilters = {
        ...initialFilters,
        currentPage: 1,
        filters: [],
        // order: "desc",
        // orderBy: "startDate"
      };
    }
    fetchContractConfig(initialFilters);
  };

  const handleCEConfigEntity = (ceId) => {
    if (ceId != "") {
      setOpenConfig(true);
      setCEId(ceId);
    } else {
      setOpenConfig(false);
      setCEId("");
    }
  };

  const editCEConfiguration = () => {
    setOpenConfig(!isOpenConfig);
  };

  const toggleConfigModal = (hasRefresh) => {
    if (isBoolean(hasRefresh) && hasRefresh) {
      refetch();
    }
    setOpenConfig(!isOpenConfig);
  };

  const handleCEContract = (ceId) => {
    if (ceId != "") {
      setOpenContract(true);
      setCEId(ceId);
    } else {
      setOpenContract(false);
      setCEId("");
    }
  };

  const editCEContract = () => {
    setOpenContract(!isOpenContract);
    refetch();
  };

  const toggleCEContractModal = (hasRefresh) => {
    if (isBoolean(hasRefresh) && hasRefresh) {
      refetch();
    }
    setOpenContract(!isOpenContract);
  };
  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };
  return (
    <div>
      <Container fluid className="width_info">
        <div className={collapseSider ? "mb-0" : "mb-3"}>
          <Card className="border-0 shadow-top" hidden={collapseSider}>
            <CardBody className="section-devider-border">
              <ErrorBoundary>
                <SearchContainer
                  initialValue={initialFilterBySearch}
                  onSearch={onSearchConfiguration}
                  onReset={onReset}
                  handleUpdateEntity={handleUpdateEntity}
                  handleCEConfigEntity={handleCEConfigEntity}
                  handleCEContract={handleCEContract}
                  module={module}
                  orgId={orgId}
                  onManualSearch={onManualSearch}
                  selectedCEId={selectedCEId}
                />
              </ErrorBoundary>
            </CardBody>
          </Card>
        </div>

        <Card>
          <CardBody className="pt-0">
            <ErrorBoundary>
              <ConfigurationTable
                module={module}
                data={state.data}
                loading={state.loading}
                onExport={handleExport2}
                filters={initialFilters}
                totalSize={state.records}
                onPageChange={onPageChange}
                coveredEntityID={selectedCoveredEntity?.coveredEntityID}
                tenantID={selectedCoveredEntity?.tenantID}
                setLoading={(value) => setState({ loading: value })}
                refetch={refetch}
                onSearchColumnFilters={handleSearchColumnFilters}
                reset={state.reset}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
                orgId={orgId}
                resetFlag={resetFlag}
                SetResetFlag={SetResetFlag}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>

      {/* <Modal
        isOpen={isOpenConfig}
        toggle={editCEConfiguration}
        size="m"
        className="m"
      >
        <ModalHeader toggle={editCEConfiguration}>
          Edit Covered Entity Configuration
        </ModalHeader>
        <ModalBody>
         
        </ModalBody>
      </Modal> */}
      <Drawer
        size="md"
        direction="end"
        isOpen={isOpenConfig}
        toggle={editCEConfiguration}
        title={"Edit Covered Entity Configuration"}
      >
        <ErrorBoundary>
          <CEConfiguration
            converEntityId={ceId}
            toggle={toggleConfigModal}
            invoiceStatus={invoiceStatus}
            module={module}
            editCEConfiguration={editCEConfiguration}
            selectedCoveredEntity={selectedCoveredEntity}
          />
        </ErrorBoundary>
      </Drawer>

      <Modal
        isOpen={isOpenContract}
        toggle={editCEContract}
        size="m"
        className="m"
      >
        <ModalHeader
          toggle={editCEContract}
          className="f-15 text-primary font-weight-700"
        >
          Add Pharmacies
        </ModalHeader>
        <ModalBody>
          <CEContract
            selectedCoveredEntity={selectedCoveredEntity}
            toggle={editCEContract}
            module={module}
            refetch={refetch}
          />
        </ModalBody>
      </Modal>
      <Drawer
        direction="end"
        title="Add/Attach Notes & Policies"
        isOpen={isOpenProgram}
        toggle={onHandleManualProgram}
        size="lg"
      >
        <ProgramNotes
          hasEditable={true}
          onClose={onHandleManualProgram}
          selectedCoveredEntity={selectedCoveredEntity}
        />
      </Drawer>
    </div>
  );
};

export default Configuration;
